import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { RefreshCcw } from "lucide-react";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const refund = async (sid) => {
    if (!confirm("Refund this order?")) return;
    try { await api.post(`/admin/orders/${sid}/refund`); toast.success("Refunded"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Refund failed"); }
  };

  return (
    <div data-testid="admin-orders-page">
      <div className="eyebrow mb-2">Orders</div>
      <h1 className="aperture-h1 text-4xl mb-10">Sales Ledger.</h1>
      <div className="bg-white rounded-sm border overflow-x-auto" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <table className="w-full text-sm">
          <thead className="bg-navy/5"><tr>{["Date","Email","Items","Total","Status","Actions"].map(h => <th key={h} className="px-4 py-3 text-left eyebrow" style={{ color: "#0A2540" }}>{h}</th>)}</tr></thead>
          <tbody>
            {orders.length === 0 && <tr><td colSpan="6" className="px-4 py-10 text-center text-navy/50">No orders yet.</td></tr>}
            {orders.map((o) => (
              <tr key={o.session_id} className="border-t" style={{ borderColor: "rgba(10,37,64,0.08)" }}>
                <td className="px-4 py-3 text-navy/70 text-xs">{new Date(o.created_at).toLocaleString()}</td>
                <td className="px-4 py-3">{o.email || "—"}</td>
                <td className="px-4 py-3">{o.items?.map(i => i.title).join(", ")}</td>
                <td className="px-4 py-3">${o.total.toFixed(2)}</td>
                <td className="px-4 py-3"><span className={`text-xs uppercase tracking-widest ${o.payment_status === "paid" ? "text-gold" : "text-navy/60"}`}>{o.payment_status}</span></td>
                <td className="px-4 py-3">
                  {o.payment_status === "paid" && (
                    <button onClick={() => refund(o.session_id)} className="inline-flex items-center gap-1 text-xs text-red-600 hover:text-red-800"><RefreshCcw className="w-3 h-3"/>Refund</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
